import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-store";
import { getKhattabatResultsStore } from "../../../../../stores/khattabat-stores/results-store";
import { TEt3PickerSingleValue } from "../../../../../TypesNEW";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../core/et3-input/et3-picker";

const PaidUsersPicker = withLiteObserverAndTheme(
  ({ showCount }: { showCount: boolean }) => {
    return (
      <Et3Picker
        label={i18n.get("PAID_USERS")}
        options={getKhattabatMatchingStore().getUsersIdsOptions(showCount)}
        value={getKhattabatMatchingStore().getCurrentPaidUserPickerValue()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getKhattabatMatchingStore().setCurrentUserInformation(value);
          getKhattabatResultsStore().setClientConversations([]);
        }}
        onEnter={() => {}}
        isMultiple={false}
        style={{}}
        onClick={() => {}}
        containerStyle={{}}
      />
    );
  }
);

export default PaidUsersPicker;
